module.exports = __webpack_public_path__ + "img/play-button.f8018d9b.png";